import axios from "axios";
import {
  DEFAULT_CONFIG,
  FALLBACK_VILLAS,
  FALLBACK_REVIEWS,
} from "@/lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function loadContent() {
  try {
    const [configRes, villasRes, reviewsRes] = await Promise.all([
      axios.get(`${API}/config`),
      axios.get(`${API}/villas`),
      axios.get(`${API}/reviews`),
    ]);
    return {
      config: { ...DEFAULT_CONFIG, ...configRes.data },
      villas: villasRes.data?.length ? villasRes.data : FALLBACK_VILLAS,
      reviews: reviewsRes.data?.length ? reviewsRes.data : FALLBACK_REVIEWS,
    };
  } catch {
    return {
      config: DEFAULT_CONFIG,
      villas: FALLBACK_VILLAS,
      reviews: FALLBACK_REVIEWS,
    };
  }
}
